export const SUPPORTED_LEGAL_LOCALES = ['pl', 'en'];
export const DEFAULT_LEGAL_LOCALE = 'pl';

export const normalizeLegalLocale = (value) => {
  if (!value || typeof value !== 'string') return DEFAULT_LEGAL_LOCALE;
  const normalized = value.toLowerCase().slice(0, 2);
  return SUPPORTED_LEGAL_LOCALES.includes(normalized) ? normalized : DEFAULT_LEGAL_LOCALE;
};

export const getLegalLocaleFromI18n = (language) => normalizeLegalLocale(language);

/** Lazy-load terms + privacy for one locale (~60–65 kB per chunk). */
export async function loadLegalBundle(locale) {
  const normalized = normalizeLegalLocale(locale);
  const mod = await import(`./bundles/${normalized}.js`);
  return {
    termsOfService: mod.termsOfService,
    privacyPolicy: mod.privacyPolicy,
  };
}
